export default "<!-- View/routes wrapper-->\n<router-outlet></router-outlet>\n";